import React from 'react';

export const ChipbaseLogo: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="9" fill="var(--teal-solid)" />
    <rect x="9" y="9" width="14" height="14" rx="2.5" fill="rgba(0,0,0,0.55)" />
    <rect x="12.5" y="12.5" width="7" height="7" rx="1" fill="var(--teal)" opacity="0.7" />
    <line x1="9" y1="13" x2="6.5" y2="13" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="9" y1="16" x2="6.5" y2="16" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="9" y1="19" x2="6.5" y2="19" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="23" y1="13" x2="25.5" y2="13" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="23" y1="16" x2="25.5" y2="16" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="23" y1="19" x2="25.5" y2="19" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="13" y1="9" x2="13" y2="6.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="16" y1="9" x2="16" y2="6.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="19" y1="9" x2="19" y2="6.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="13" y1="23" x2="13" y2="25.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="16" y1="23" x2="16" y2="25.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="19" y1="23" x2="19" y2="25.5" stroke="rgba(255,255,255,0.9)" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

type BrandMarkSize = 'sm' | 'md' | 'lg';

export const BrandMark: React.FC<{ size?: BrandMarkSize }> = ({ size = 'md' }) => {
  const sz = size === 'lg' ? 36 : size === 'sm' ? 26 : 30;
  const fs = size === 'lg' ? 18 : size === 'sm' ? 13 : 15;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: sz * 0.3 }}>
      <ChipbaseLogo size={sz} />
      <div style={{ letterSpacing: '-0.04em', lineHeight: 1 }}>
        <span style={{ fontWeight: 800, fontSize: fs, color: 'var(--text0)' }}>Chip</span>
        <span style={{ fontWeight: 800, fontSize: fs, color: 'var(--teal)' }}>BASE</span>
      </div>
    </div>
  );
};
